import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Sidebar from './components/Sidebar';
import MobileNav from './components/MobileNav';
import TopBar from './components/TopBar';
import Dashboard from './components/Dashboard';
import BadgeCantiere from './components/BadgeCantiere';
import Presenze from './components/Presenze';
import Sicurezza from './components/Sicurezza';
import Documenti from './components/Documenti';
import Pianificazione from './components/Pianificazione';
import Reportistica from './components/Reportistica';
import Cantieri from './components/Cantieri';
import RegistroPaga from './components/RegistroPaga';
import Magazzino from './components/Magazzino';
import Backup from './components/Backup';
import FattureForni from './components/FattureForni';
import ComputoMetrico from './components/ComputoMetrico';
import Appuntamenti from './components/Appuntamenti';
import LoginPage from './components/LoginPage';
import AuthCallback from './components/AuthCallback';
import SitoWeb from './components/SitoWeb';
import SitoWeb2 from './components/SitoWeb2';
import InstagramGraphics from './components/InstagramGraphics';
import QRPage from './components/QRPage';
import SitoLemir from './components/SitoLemir';
import Timbra from './components/Timbra';
import AnalisiCosti from './components/AnalisiCosti';
import api from './api';

const ProtectedApp = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user && !location.pathname.startsWith('/login')) {
      navigate('/login', { replace: true });
    }
  }, [user, loading, navigate, location]);

  useEffect(() => { if (user) api.seed().catch(() => {}); }, [user]);

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f5f7fa' }}>
      <div className="spin" style={{ width: 32, height: 32, border: '3px solid #e5e7eb', borderTopColor: '#3b82f6', borderRadius: '50%' }} />
    </div>
  );

  // Check for OAuth callback
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  if (!user) return <LoginPage />;

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <TopBar />
        <Routes>
          <Route path="" element={<Dashboard />} />
          <Route path="badge" element={<BadgeCantiere />} />
          <Route path="presenze" element={<Presenze />} />
          <Route path="sicurezza" element={<Sicurezza />} />
          <Route path="documenti" element={<Documenti />} />
          <Route path="pianificazione" element={<Pianificazione />} />
          <Route path="reportistica" element={<Reportistica />} />
          <Route path="cantieri" element={<Cantieri />} />
          <Route path="paga" element={<RegistroPaga />} />
          <Route path="magazzino" element={<Magazzino />} />
          <Route path="backup" element={<Backup />} />
          <Route path="fatture" element={<FattureForni />} />
          <Route path="computo" element={<ComputoMetrico />} />
          <Route path="appuntamenti" element={<Appuntamenti />} />
          <Route path="analisi-costi" element={<AnalisiCosti />} />
        </Routes>
      </main>
      <MobileNav />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Sito web pubblico */}
          <Route path="/" element={<SitoWeb />} />
          <Route path="/sito2" element={<SitoWeb2 />} />
          <Route path="/instagram" element={<InstagramGraphics />} />
          <Route path="/qrcode" element={<QRPage />} />
          <Route path="/lemir" element={<SitoLemir />} />
          <Route path="/timbra" element={<Timbra />} />
          {/* Login page */}
          <Route path="/login" element={
            <AuthProvider><LoginPage /></AuthProvider>
          } />
          {/* App protetta */}
          <Route path="/app/*" element={
            <AuthProvider><ProtectedApp /></AuthProvider>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
